module.exports = new __parcel__URL__("fondo.ac83e7bf.png").toString();